(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/hooks/assets/javascripts/use-casino-display-size.js') >= 0) return;  svs.modules.push('/components/casino-react/hooks/assets/javascripts/use-casino-display-size.js');

'use strict';

const {
  CasinoDisplaySize
} = svs.components.casino_react.common.constants;
const {
  useMediaQueryWatcher
} = svs.components.lbUtils.useMediaQuery;
const {
  BREAKPOINT_XS,
  BREAKPOINT_SM,
  BREAKPOINT_AM,
  BREAKPOINT_MD,
  BREAKPOINT_LG,
  BREAKPOINT_XL
} = svs.components.lbUtils.useMediaQuery;
const useCasinoDisplaySize = () => {
  const breakpoint = useMediaQueryWatcher();
  switch (breakpoint) {
    case BREAKPOINT_XS:
    case BREAKPOINT_SM:
    case BREAKPOINT_AM:
      return CasinoDisplaySize.SMALL;
    case BREAKPOINT_MD:
      return CasinoDisplaySize.MEDIUM;
    case BREAKPOINT_LG:
    case BREAKPOINT_XL:
    default:
      return CasinoDisplaySize.LARGE;
  }
};
setGlobal('svs.components.casino_react.hooks.useCasinoDisplaySize', useCasinoDisplaySize);

 })(window);